<template>
  <div class="mainContainer">
    <v-btn class="infoButton" density="compact" icon="mdi-information" v-if="workshopId != undefined" @click="infoDialog = true">
    </v-btn>
    <v-dialog
        transition="dialog-bottom-transition"
        width="70%"
        v-model="infoDialog">
      <template v-slot:default>
        <v-card>
          <v-toolbar
              color="primary"
              title="Info"
          >
            <v-btn icon @click="infoDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <div class="companyId">CompanyId: {{customerId}}</div>
          <div class="workshopId">WorkshopId: {{workshopId}}</div>
          <div v-if="userKey != undefined" class="user">Name: {{name}}</div>
        </v-card>
      </template>
    </v-dialog>

    <div class="registration" v-if="userKey == undefined">
      <div class="userFields">
        <v-text-field class="input" type="text" placeholder="Name" v-model="name"/>
        <v-btn class="userEnterButton" color="primary" :disabled="name==''" @click="enterWorkshop">Enter Workshop</v-btn>
      </div>
    </div>
    <div v-if="userKey != undefined">
      <div class="votingNotStarted" v-if="activeVoting == undefined || (activeVoting !== undefined && activeVoting.ended == true)">
        <div>Voting not Started</div>
        <div>or </div>
        <div>you have already voted</div>
      </div>
      <div v-if="activeVoting != undefined && (!ended && selectedCard !== undefined)">
        <v-container fluid>
          <div no-gutters class="flex-column fill-height">
            <!-- Beschreibungsbereich -->
            <v-col class="description-area" :class="{ 'active': !expandCards }">
              <div class="expandOverlay" @click="expandCards=false" v-if="expandCards == true"></div>
              <v-card class="detailCard">
                <v-toolbar
                    :style="{backgroundColor: getActiveSegment().color}"
                    :title="getActiveSegment().text[lang].name"
                >
                </v-toolbar>
                <div class="details">
                  <div class="font-weight-black">Description:</div>
                  <div>{{getActiveSegment().text[lang].description}}</div>
                  <div class="font-weight-black">Example:</div>
                  <div>{{getActiveSegment().text[lang].example}}</div>
                </div>
              </v-card>
            </v-col>

            <!-- Divider mit Button -->
            <div ref="divider" class="divider-area text-center">
              <span ref="dividerButton" class="divider-button-container" @click="toggleExpand">
                <span class="divider-button">
                  <v-icon class="divider-button-icon" :class="{'rotate':expandCards}">mdi-chevron-up</v-icon>
                </span>
              </span>
            </div>

            <!-- Kartenbereich -->
            <div class="cards-area" :class="{ 'active': expandCards, 'fixed': fixedSelection != undefined && fixedSelectionWhereWeAre != undefined }">
              <div class="expandOverlay" @click="expandCards=true" v-if="expandCards == false"></div>
              <div v-if="fixedSelection == undefined">
                <div class="cards-row-container">
                  <div class="cards-row">
                    <v-card :disabled="fixedSelection != undefined || ended " v-for="(card, index) in cards" :key="index" :class="{'selected-card': (selectedCard != undefined && selectedCard.value === card.value)||(fixedSelection != undefined && fixedSelection.value === card.value)}" class="card" @click="selectCard(card)" @touchstart="selectCard(card)" elevation="2">
                      <v-card-title class="card-headline">{{ card.visualValue }}</v-card-title>
                      <div class="card-divider"></div>
                      <v-card-text class="card-text">{{ card.text[lang].description }}</v-card-text>
                    </v-card>
                  </div>
                </div>
                <div class="voteDiv">
                  <v-btn class="vote" :disabled="!selectedCard || fixedSelection != undefined || ended" color="primary" @click="saveSelectedCard">Fix where we want to be</v-btn>
                </div>
              </div>
              <div>
                <div class="cards-row-container">
                  <div class="cards-row">
                    <v-card :disabled="fixedSelectionWhereWeAre != undefined || ended " v-for="(card, index) in cards" :key="index" :class="{'selected-card': (selectedCardWhereWeAre != undefined && selectedCardWhereWeAre.value === card.value)||(fixedSelectionWhereWeAre != undefined && fixedSelectionWhereWeAre.value === card.value)}" class="card" @click="selectCardWhereWeAre(card)" @touchstart="selectCardWhereWeAre(card)" elevation="2">
                      <v-card-title class="card-headline">{{ card.visualValue }}</v-card-title>
                      <div class="card-divider"></div>
                      <v-card-text class="card-text">{{ card.text[lang].description }}</v-card-text>
                    </v-card>
                  </div>
                </div>
                <div class="voteDiv">
                  <v-btn class="vote" :disabled="!selectedCardWhereWeAre || fixedSelectionWhereWeAre != undefined || ended" color="primary" @click="fixSelection">Fix where we are</v-btn>
                </div>
              </div>
            </div>
          </div>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import { getDatabase, ref, push } from 'firebase/database';
import {onActiveVotingChange, voting} from "@/workshop/workshopFunctions";
import segmentData from '../data/segment.json'
import segmentCardData from '../data/segmentVoting.json'
export default {
  name: "workshopUser",
  components: {},
  computed: {
    workshopId() {
      return this.$route.params.workshopId;
    },
    customerId() {
      return this.$route.params.customerId;
    },
    lang() {
      return this.$route.params.lang;
    },
    cards() {
      return segmentCardData;
    },
    ended(){
      if(this.activeVoting){
        return Date.now() > this.activeVoting.endTime || this.activeVoting.ended == true;
      }
      return false;
    }
  },
  watch: {
    percentTimeLeft() {
      this.updatePercentTimeLeft();
    }
  },
  mounted() {
    this.$store.dispatch('saveCustomerId', this.customerId);
    window.addEventListener('resize', () => {
      // We execute the same script as before
      this.setHeight();
    });
    this.setHeight();

    const workshopId = this.$store.getters.getWorkshopId;
    this.workshopId = workshopId;
    if(this.workshopId != null){
      onActiveVotingChange(this.workshopId, this.activeVotingChange);
    }
    const user = this.$store.getters.getVotingUser;

    if (user) {
      // Benutzer ist gesetzt, führen Sie erforderliche Aktionen aus...
      this.name = user.name;
      this.userKey = user.userKey;
      this.fixedSelection = this.$store.getters.getUserVote;
    }
  },
  beforeUnmount() {
    clearInterval(this.timerInterval);
  },
  data() {
    return {
      votingSegment: undefined,
      startTime: undefined,
      name: '',
      userKey: undefined,
      activeVoting: undefined,
      infoDialog: false,
      selectedCard: null,
      fixedSelection: undefined,
      selectedCardWhereWeAre: null,
      fixedSelectionWhereWeAre: undefined,
      expandCards: false,
      percentTimeLeft: 100,
      timerInterval: null,
      dividerDivWidth: null,
      buttonWidth: null,
      buttonWidthFrom: null,
      buttonWidthTo: null,
    }
  },
  methods: {
    setHeight(){
      let vh = window.innerHeight;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      document.documentElement.style.setProperty('--vh15', `${vh*0.15-2}px`);
      document.documentElement.style.setProperty('--vh85', `${vh*0.85-2}px`);
      document.documentElement.style.setProperty('--vh85_80', `${(vh*0.85-2)*0.80}px`);
      document.documentElement.style.setProperty('--vh85_20', `${(vh*0.85-2)*0.20}px`);
    },
    updatePercentTimeLeft() {
      if(this.activeVoting != null){
        if(this.$refs['divider'] != undefined && this.dividerDivWidth == null){
          this.dividerDivWidth = this.$refs['divider']['offsetWidth'];
          this.buttonWidth = this.$refs['dividerButton']['offsetWidth'];
          this.buttonWidthFrom = this.dividerDivWidth/2-this.buttonWidth/2;
          this.buttonWidthTo = this.dividerDivWidth/2+this.buttonWidth/2;
        }
        const startTime = this.activeVoting.startTime;

        // eslint-disable-next-line no-unused-vars
        const now = Date.now();
        if (this.activeVoting == undefined || (this.activeVoting !== undefined && (this.activeVoting.ended == true || now >= this.activeVoting.endTime|0))) {
          this.percentage = 100;
          clearInterval(this.timerInterval); // Stoppt den Timer, wenn die Endzeit erreicht ist
        } else {
          const endTime = this.activeVoting.endTime;
          const elapsed = now - startTime;
          const total = endTime - startTime;
          this.percentTimeLeft = 100 - ((elapsed / total) * 100);
          const pixelLeft = this.dividerDivWidth*this.percentTimeLeft/100;

          let buttonPercentTimeLeft = 100;
          if(pixelLeft>this.buttonWidthTo){
            buttonPercentTimeLeft = 100;
          } else if(pixelLeft< this.buttonWidthFrom) {
            buttonPercentTimeLeft = 0;
          } else {
            buttonPercentTimeLeft = 100-((this.buttonWidthTo-pixelLeft)*100/this.buttonWidth);
          }
          // Aktualisiert die CSS-Variable, wenn benötigt
          document.documentElement.style.setProperty('--divider-gradient-percentage', `${this.percentTimeLeft}%`);
          document.documentElement.style.setProperty('--divider-button-gradient-percentage', `${buttonPercentTimeLeft}%`);
          document.documentElement.style.setProperty('--divider-color', this.lightenDarkenColor(this.getActiveSegment().color, -30));
        }
      }
    },
    selectCard(value) {
        this.selectedCard = value;
    },
    selectCardWhereWeAre(value) {
        this.selectedCardWhereWeAre = value;
    },
    fixSelection() {
      clearInterval(this.timerInterval);
      this.fixedSelectionWhereWeAre = this.selectedCardWhereWeAre;
      this.$store.dispatch('saveUserVote', {voteWhereWantToBe: this.fixedSelection, voteWhereWeAre: this.fixedSelectionWhereWeAre});
      voting(this.workshopId, this.userKey, this.name, this.fixedSelection.value, this.fixedSelectionWhereWeAre.value, Date.now()-this.activeVoting.startTime);
    },
    saveSelectedCard() {
      this.fixedSelection = this.selectedCard;
    },
    toggleExpand() {
      this.expandCards = !this.expandCards;
    },
    getActiveSegment(id = this.activeVoting.segmentId, dataArray=segmentData){
      for (const obj of dataArray) {
        if (obj.id === id) {
          return obj;
        } else if (obj.children) {
          const foundInChildren = this.getActiveSegment(id, obj.children);
          if (foundInChildren) {
            return foundInChildren;
          }
        }
      }
      return null; // Wenn die ID nicht gefunden wurde
    },
    async enterWorkshop(){
      const db = getDatabase();
      // Ref auf den Workshop
      const workshopRef = ref(db, `customers/${this.customerId}/workshop/${this.workshopId}/users`);
// Neues Element unter workshop/workshopId hinzufügen
      const userRef = await push(workshopRef, {
        name: this.name,
      });
      this.userKey = userRef.key;
      this.$store.dispatch('saveVotingUser', { name: this.name, userKey: this.userKey });
      this.$store.dispatch('saveWorkshopId', this.workshopId);
      onActiveVotingChange(this.workshopId, this.activeVotingChange);
    },
    activeVotingChange(activeVoting){
      this.activeVoting = activeVoting;
      if(this.activeVoting != null && this.activeVoting != undefined){
        this.updatePercentTimeLeft();
        this.timerInterval = setInterval(this.updatePercentTimeLeft, 100);
        if(this.votingSegment !== this.activeVoting.segmentId || this.startTime != this.activeVoting.startTime) {
          this.votingSegment = this.activeVoting.segmentId;
          this.startTime = this.activeVoting.startTime;
          this.selectedCard = null;
          this.fixedSelection = undefined;
          this.selectedCardWhereWeAre = null;
          this.fixedSelectionWhereWeAre = undefined;
          this.expandCards = false;
        } else if(this.activeVoting != undefined && this.activeVoting.ended){
          this.votingSegment = undefined;
          this.fixedSelection = undefined;
          this.fixedSelectionWhereWeAre = undefined;
          clearInterval(this.timerInterval); // Stoppt den Timer, wenn die Endzeit erreicht ist
        }
      }
    },
    lightenDarkenColor(col, amt) {
      var num = parseInt(col.substr(1), 16);
      var r = (num >> 16) + amt;
      var b = ((num >> 8) & 0x00FF) + amt;
      var g = (num & 0x0000FF) + amt;
      var newColor = g | (b << 8) | (r << 16);
      return "#"+newColor.toString(16);
    },
  }
}
</script>

<style scoped>
  :root {
    --divider-gradient-percentage: 0%; /* Standardwert */
    --divider-button-gradient-percentage: 0%; /* Standardwert */
    --divider-color: blue; /* Standardwert */
    --vh: 600px; /* Standardwert */
    --vh15: 600px; /* Standardwert */
    --vh85: 600px; /* Standardwert */
    --vh85_80: 600px;
    --vh85_20: 600px;
  }
  .mainContainer{
    background-color: lightgray;
    height: var(--vh) !important;
  }

  .infoButton{
    position: absolute;
    top: 20px;
    right: 20px;
    background: white;
    z-index: 100;
  }
  .description-area, .cards-area {
    position: relative;
    transition: all 1s ease;
    flex: 0 0 var(--vh15); /* Inaktiver Bereich ist kleiner */
    opacity: 0.5; /* Inaktiver Bereich ist teilweise durchsichtig */
    z-index: 1;
    overflow-y: hidden;
    height: var(--vh15);
  }

  .cards-area {
    margin-top: 10px;
  }
  .registration {
    position: relative;
    width: 100vw;
    height: var(--vh);
  }
  .userFields {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80vw;
  }
  .userEnterButton{
    width: 100%;
  }
  .expandOverlay{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(201, 200, 200, 0.30);
    z-index: 9;
    cursor: pointer;
  }

  .active {
    flex: 0 0 var(--vh85); /* Aktiver Bereich nimmt mehr Platz ein */
    opacity: 1; /* Aktiver Bereich ist vollständig deckend */
    height: var(--vh85);
  }

  .cards-row-container {
    margin: 0 auto;
    overflow-x: auto;
  }
  .cards-row {
    display: flex;
    flex-wrap: nowrap; /* Verhindert das Umbrechen der Karten */
    scroll-snap-type: x mandatory; /* Aktiviert Scroll Snapping für horizontales Scrollen */
    -webkit-overflow-scrolling: touch; /* Verbessert das Scrollen auf WebKit-basierten Browsern */
    margin: 0px 10px;
    width: fit-content;
    overflow: hidden;
  }
  /* Der Scrollbalken selbst */
  .cards-row-container::-webkit-scrollbar {
    height: 4px;
    border-radius: 5px;
    width: 6px; /* Breite des Scrollbalkens */
  }

  /* Der Hintergrund des Scrollbalkens (Track) */
  .cards-row-container::-webkit-scrollbar-track {
    background: #f1f1f1; /* Farbe des Hintergrunds */
  }

  /* Der bewegbare Teil des Scrollbalkens (Thumb) */
  .cards-row-container::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #888; /* Farbe des bewegbaren Teils */
  }

  /* Der bewegbare Teil des Scrollbalkens beim Hover */
  .cards-row-container::-webkit-scrollbar-thumb:hover {
    background: #555; /* Farbe beim Hover */
  }

  .divider-area {
    position: relative;
    transition: background 1s linear;
    background: linear-gradient(to right, var(--divider-color) var(--divider-gradient-percentage), gray var(--divider-gradient-percentage));
    height: 4px;
    border-radius: 2px;
    cursor: pointer;
    margin: 0px 0px;
  }
  .divider-button-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    cursor: pointer;
    width: 100px;
    transition: background 1s linear;
    background: linear-gradient(to right, var(--divider-color) var(--divider-button-gradient-percentage), gray var(--divider-button-gradient-percentage));
    border-radius: 25px;
    padding: 4px; /* Abstand für den "Rand" */
    z-index: 10;

  }

  .divider-button {
    display: inline-block;
    background-color: white; /* Oder eine andere Hintergrundfarbe */
    border: none; /* Entfernt den Standardrand */
    width: 92px;
    border-radius: 25px; /* Stellen Sie sicher, dass dies kleiner als der Container-border-radius ist, falls verwendet */
  }

  .selected-card {
    border: #c7c7c7;
    background-color: #E0E0E0;
  }

  .headline {
    font-size: 24px;
    font-weight: bold;
  }

  .overflow-auto {
    overflow: auto;
  }

  .card {
    z-index: 2;
    flex: 0 0 auto;
    width: 400px;
    height: var(--vh85_80);
    max-width: 80vw;
    max-height: 60vh;
    margin: 10px;
    scroll-snap-align: start; /* Sorgt dafür, dass die Karten am Anfang des Containers einrasten */
    border-width: 2px;
    transition: all 1s linear;

  }
  .cards-area.fixed .card:not(.selected-card) {
    opacity: 0;
    width: 0px;
    overflow: hidden;
    margin: 0px;
  }

  .cards-area.fixed .cards-row {
    overflow: hidden;
    width: 420px;
    margin: 0 auto;
  }

  .vote {
    margin-top: 10px;
  }

  .voteDiv {
    height: var(--vh85_20);
    text-align: center;
  }

  .card-headline, .card-text {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .card-headline{
    font-size: 74px;
    height: calc(40% - 20px);
  }
  .card-divider{
    text-align: center;
    height: 4px;
    background: #e7e7e7;
    margin: 10px 18px;
  }
  .card-text{
    font-size: 20px;
    line-height: 23px;
    height: calc(60% - 20px);
  }
  .divider-button-icon{
    transition: transform 0.5s ease;
  }
  .divider-button-icon.rotate{
    transform: rotate(180deg);
  }
  .votingNotStarted {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 36px;
    text-align: center;
  }
  .details {
    margin: 10px 20px;
  }
  .detailCard {
    height: 90%;
    width: 80%;
    margin: auto;
  }
</style>